"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#004864"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m19.4 5.18a9.47 9.47 0 0 0 -9.3-2.95 9.91 9.91 0 0 0 -7.49 8.2l-.78-1.16a1 1 0 0 0 -1.66 1.12l2.83 4.15a1 1 0 0 0 1.59.08l3.21-3.84a1 1 0 0 0 -.13-1.4 1 1 0 0 0 -1.41.12l-1.75 2.06a7.87 7.87 0 0 1 6.05-7.38 7.49 7.49 0 0 1 7.35 2.33 1 1 0 1 0 1.49-1.33z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m23.83 13.61-2.83-4.15a1 1 0 0 0 -1.59-.08l-3.21 3.84a1 1 0 0 0 .13 1.4 1 1 0 0 0 1.41-.12l1.71-2.06a7.87 7.87 0 0 1 -6 7.38 7.49 7.49 0 0 1 -7.35-2.33 1 1 0 1 0 -1.5 1.33 9.46 9.46 0 0 0 9.3 2.95 9.91 9.91 0 0 0 7.49-8.2l.78 1.16a1 1 0 0 0 1.66-1.12z"
  })));
};

exports["default"] = _default;